
import { computed, defineComponent } from "vue";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import useBreakpoints from "@/services/Breakpoints";

export default defineComponent({
  setup() {
    const { type } = useBreakpoints();
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const goTo = (to) => {
      router.push({ name: to, params: { eventID: eventData.value.id } });
    };
    return {
      route,
      goTo,
      type,
    };
  },
});
